import 'tachyons'
//import './engines/index'
//import Dispatch from './Dispatcher'

import './engines/ui'
import './engines/brewfest'

import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'world'
	}
});

export default app;